/**
 * Klaviyo email subscription handler.
 *
 * Attaches a submit listener to every `[data-klaviyo-form]` element on the
 * page. All Klaviyo configuration is passed in via `data-*` attributes on the
 * `<form>` element, so this file contains no Liquid and can be reused across
 * any section or template — just add the required attributes to the form.
 *
 * Required `data-*` attributes on the form:
 * data-klaviyo-form  - Presence of this attribute marks the form for handling (value is ignored).
 * data-list-id       - Klaviyo list ID to subscribe the profile to (e.g. "Y6nRLr").
 * data-company-id    - Klaviyo public API / company key (e.g. "MCYMmp").
 * data-redirect      - Path to navigate to on successful subscription (e.g. "/pages/teaser-thank-you-page").
 *
 * On submit the handler:
 * 1. Runs native browser email validation via `validity.valid` / `reportValidity()`.
 * 2. POSTs to the Klaviyo client subscriptions endpoint using the JSON:API payload format.
 * 3. Redirects to `data-redirect` on a 2xx response, or removes the `hidden` class from `.error_message` on failure.
 */
document.querySelectorAll('[data-klaviyo-form]').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var emailInput = form.querySelector('input[type="email"]');
    var errorEl = form.querySelector('.error_message');
    var listId = form.dataset.listId;
    var companyId = form.dataset.companyId;
    var redirect = form.dataset.redirect;

    if (!emailInput.validity.valid) {
      emailInput.reportValidity();
      return;
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: emailInput.value.trim() }
            }
          },
          custom_source: '$embed'
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-01-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (result) {
        if (result.ok) {
          window.location.href = redirect;
        } else {
          errorEl.classList.remove('hidden');
        }
      })
      .catch(function () {
        errorEl.classList.remove('hidden');
      });
  });
});
